import Grid from "@mui/material/Grid";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

export default function UserInfos({ email, setEmail, phoneNumber, setPhoneNumber, edit }) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            variant="standard"
            type="email"
            label="Adresse email"
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={phoneNumber}
            onChange={(event) => setPhoneNumber(event.target.value)}
            required
            variant="standard"
            type="text"
            label="Numéro de téléphone"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
